(function () {
  'use strict';

  angular.module('eclipseApp.user')

    .factory('userService', ['$modal', '$rootScope', '$window', function ($modal, $rootScope, $window) {

      var service = {
        isResetPasswordModalOpen : false,
        isAutoRegModalOpen: false
      };

      service.promptResetPassword = function () {
        service.isResetPasswordModalOpen = true;
        $modal.open({
          templateUrl: 'modules/user/views/reset-password.html',
          controller: 'resetPasswordCtrl',
          size: 'md',
          backdrop: false
        }).result.finally(function() {
          service.isResetPasswordModalOpen = false;
        });
      };

      service.promptAutoRegComplete = function () {
        service.isAutoRegModalOpen = true;
        $modal.open({
          templateUrl: 'modules/user/views/registration-complete.html',
          controller: 'registrationCompleteCtrl',
          size: 'md',
          backdrop: false
        }).result.finally(function() {
          service.isAutoRegModalOpen = false;
        });
      };

      // service.promptSecurityQAComplete = function () {
      //   $modal.open({
      //     templateUrl: 'modules/user/views/set-securityqa.html',
      //     controller: 'setSecurityQACtrl',
      //     size: 'md',
      //     backdrop: false
      //   });
      // };


      service.promptRelinkAccount = function () {
        $modal.open({
          templateUrl: 'modules/user/views/prompt-relink-account.html',
          controller: 'promptRelinkAccountCtrl',
          size: 'md',
          backdrop: false
        });
      };


      service.login = function ($userdata) {
        /* make sure logic goes here after login */
        $rootScope.userInfo = $userdata;
        $.cookie.json = false;

        if ($rootScope.userInfo) {
          $.cookie('pageUserName', $rootScope.userInfo.firstName + ' ' + $rootScope.userInfo.lastName, {
            //expires: 30,
            path: '/'
          });

          if(typeof $window.fdlHead === 'object' && typeof $window.fdlHead.headerState === 'function') {
            $window.fdlHead.headerState(); //logic exists in cms/common/js/fido-header-footer.js
          }
        }
      };

      return service;

    }]);
})();
